export const computesResponseAdapter = (response) => {
  return response ? response?.response : [];
};
